import client from './client';

export default (region: string, urlMetadata: any, err: any) => {
    console.log('Unable to generate BetPlace URL', {
        region: region,
        urlMetadata: urlMetadata,
        context: 'BetPlacePage#getBetUrl',
        error: err,
    });
    client.error('Unable to generate BetPlace URL', {
        region: region,
        urlMetadata: urlMetadata,
        context: 'BetPlacePage#getBetUrl',
        error: err,
    });
};
